module.exports = "/images/kp.svg?e93cd70fb54730c09f3f3d86ba18ea11";